import classNames from "classnames/bind";

import style from './Policy.module.scss';

const cx = classNames.bind(style);

function Policy() {
    return (
        <div className={cx('policy')}>

        </div>
    );
}

export default Policy;